"use client";

import { useTranslations } from "next-intl";
import { Check } from "@phosphor-icons/react/dist/ssr";
import FounderSeal from "@/components/ui/FounderSeal";
import { BADGE_OUTLINE, BADGE_NEUTRAL } from "@/lib/badge-styles";

interface BadgeProps {
  variant?: "verified" | "founder" | "category";
  children: React.ReactNode;
  className?: string;
}

export default function Badge({ variant = "category", children, className = "" }: BadgeProps) {
  const t = useTranslations("a11y");
  if (variant === "founder") {
    return (
      <span
        className={`${BADGE_OUTLINE} border-gold ${className}`}
        aria-label={t("foundingMember")}
      >
        <FounderSeal size={13} className="text-gold" />
        <span>{children}</span>
      </span>
    );
  }
  if (variant === "verified") {
    return (
      <span
        className={`${BADGE_OUTLINE} border-green ${className}`}
        aria-label={t("verifiedProfessional")}
      >
        <Check aria-hidden="true" className="w-13 h-13 text-green" weight="bold" />
        <span>{children}</span>
      </span>
    );
  }

  return (
    <span
      className={`${BADGE_NEUTRAL} ${className}`}
    >
      {children}
    </span>
  );
}
